import * as types from '../mutation-types';
import {unionState, toDateTimeString} from '../helpers';

const state = () => ({
	types: [],
});

const actions = {
	fetchAll({commit}) {
		return axios.get('/api/restaurant-types').then(response => {
			commit(types.STORE_RESTAURANT_TYPES, response.data);
		});
	},

	create({commit}, {name}) {
		return axios.post('/api/restaurant-types', {name}).then(response => {
			commit(types.STORE_RESTAURANT_TYPE, response.data);

			return response.data;
		});
	},

	fetch({commit}, {id}) {
		return axios.get(`/api/restaurant-types/${id}`).then(response => {
			commit(types.STORE_RESTAURANT_TYPE, response.data);

			return response.data;
		});
	},

	delete({commit}, {id}) {
		return axios.delete(`/api/restaurant-types/${id}`).then(() => {
			commit(types.DELETE_RESTAURANT_TYPE, id);
		});
	},

	restore({commit}, {id}) {
		return axios.patch(`/api/restaurant-types/${id}`).then(() => {
			commit(types.RESTORE_RESTAURANT_TYPE, id);
		});
	},

	update({commit}, {id, name}) {
		return axios.put(`/api/restaurant-types/${id}`, {name}).then(response => {
			commit(types.STORE_RESTAURANT_TYPE, response.data);

			return response.data;
		});
	}
};

const mutations = {
	[types.STORE_RESTAURANT_TYPES](state, types) {
		state.types = unionState(state.types, types);
	},

	[types.STORE_RESTAURANT_TYPE](state, type) {
		state.types = unionState(state.types, [type]);
	},

	[types.DELETE_RESTAURANT_TYPE](state, id) {
		const type = state.types.find(p => p.id === id);
		type.deleted_at = toDateTimeString(new Date());
	},

	[types.RESTORE_RESTAURANT_TYPE](state, id) {
		const type = state.types.find(p => p.id === id);
		type.deleted_at = null;
	}
};

const getters = {
	getById: state => id => state.types.find(t => t.id === id),
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};